import clsx from "clsx";
import Button from "components/common/Button";
import React from "react";

type SpaceEmptyContentProps = {
    title: string;
    icon: string;
    description: string;
    action?: () => void;
    actionText?: string;
} & React.HTMLAttributes<HTMLDivElement>;

export default function SpaceEmptyContent(props: SpaceEmptyContentProps) {
    const { title, icon, description, action, actionText, className, ...rest } = props;
    return (
        <div
            className={clsx("h-full flex flex-col items-center justify-center", className)}
            {...rest}
        >
            <div className="max-w-[290px] flex flex-col items-center justify-center">
                <i
                    className={clsx(
                        icon && "ri-chat-new-line",
                        "text-[#042821] text-[22px] leading-[24px]",
                        icon
                    )}
                ></i>

                <p className="font-rocGroteskMedium text-[16px] font-semibold text-[#042821] mt-[16px]">
                    {title}
                </p>
                <p className="text-slate-500 text-[14px] text-center">{description}</p>
                {action && actionText && (
                    <Button
                        btnText={actionText}
                        onClick={action}
                        btnClassname="mt-[16px] !w-fit !px-[16px] !py-[8px]"
                    />
                )}
            </div>
        </div>
    );
}
